import { Link } from "react-router-dom";
import "./bio.css";

const BioSkeleton = () => (
  <div className="bio-skeleton" aria-hidden="true">
    <div className="skeleton-line skeleton-line--full" />
    <div className="skeleton-line skeleton-line--full" />
    <div className="skeleton-line skeleton-line--full" />
    <div className="skeleton-line skeleton-line--short" />
    <div className="skeleton-line skeleton-line--full" />
    <div className="skeleton-line skeleton-line--three-quarters" />
  </div>
);

const renderBioParagraphs = (bioText) => {
  // Split on double or single newlines first
  const paragraphs = bioText
    .split(/\n\n|\n/)
    .map((p) => p.trim())
    .filter((p) => p.length > 0);

  if (paragraphs.length > 1) {
    return paragraphs.map((para, i) => <p key={i}>{para}</p>);
  }

  // Single block — split at "My sound blends" as fallback
  const splitPoint = bioText.indexOf("My sound blends");
  if (splitPoint !== -1) {
    return (
      <>
        <p>{bioText.slice(0, splitPoint).trim()}</p>
        <p>{bioText.slice(splitPoint).trim()}</p>
      </>
    );
  }

  return <p>{bioText}</p>;
};

// bio prop comes from App.jsx — fetched once, never re-fetched on navigation
const Bio = ({ bio }) => {
  return (
    <div className="bio-page">
      {/* Hero Section */}
      <section className="bio-hero-section">
        <div className="container">
          <div className="bio-hero-content">
            <h1 className="bio-title text-gradient">About Anjali</h1>
            <p className="bio-subtitle">Singer • Songwriter • Storyteller</p>
          </div>
        </div>
      </section>

      {/* Main Bio Content */}
      <section className="bio-content-section">
        <div className="container">
          <div className="bio-layout">
            <div className="bio-image">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/anjalidmusic.firebasestorage.app/o/images%2Fgraduation%20picture.jpg?alt=media&token=89f847b6-c1d3-4e84-bd16-532606c80a00"
                alt="Anjali Daswani"
                className="bio-photo"
              />
            </div>

            <div className="bio-text">
              <div className="bio-story">
                <h2>My Journey</h2>

                <div className="bio-load-area">
                  {bio?.bioPage ? (
                    <div className="bio-fade-in">
                      {renderBioParagraphs(bio.bioPage)}
                    </div>
                  ) : (
                    <BioSkeleton />
                  )}
                </div>
              </div>

              <div className="bio-highlights">
                <h3>Musical Influences</h3>
                <div className="highlight-grid">
                  <div className="highlight-item">
                    <h4>Pop Sensibilities</h4>
                    <p>Catchy melodies that stick with you</p>
                  </div>
                  <div className="highlight-item">
                    <h4>R&B Soul</h4>
                    <p>Rich vocals with emotional depth</p>
                  </div>
                  <div className="highlight-item">
                    <h4>Folk Storytelling</h4>
                    <p>Authentic narratives from lived experience</p>
                  </div>
                  <div className="highlight-item">
                    <h4>Global Perspective</h4>
                    <p>Music influenced by cultures worldwide</p>
                  </div>
                </div>
              </div>

              <div className="bio-cta">
                <h3>Ready to Listen?</h3>
                <p>Experience the stories through music</p>
                <div className="bio-buttons">
                  <Link to="/music" className="btn-primary">
                    Listen to My Music
                  </Link>
                  <Link to="/contact" className="btn-secondary">
                    Get in Touch
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Bio;
